import "./AddDashboardDialogComponent.scss";
import template from "./AddDashboardDialogComponent.html";
import {IComponentOptions} from "angular";
import { IModalInstanceService } from "angular-ui-bootstrap";
import {DashboardLayout} from "../../../models/DashboardViewConfiguration";
import {AddDashboardConfiguration} from "../models/AddDashboardConfiguration";

export const AddDashboardDialog = "tfAddDashboardDialog";

export function addDashboardDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<"
        },
        controllerAs: "ctrl",
        controller: AddDashboardDialogComponentController
    };
}

export class AddDashboardDialogComponentController {

    /** @input */
    public readonly modalInstance: IModalInstanceService;

    public name: string | null = null;
    public layout = DashboardLayout.SINGLE;

    public close() {
        this.modalInstance.dismiss();
    }

    public add() {
        if ((this.name == null) || (this.name === "")) {
            return;
        }
        const model: AddDashboardConfiguration = {
            name: this.name,
            layout: this.layout
        };
        this.modalInstance.close(model);
    }
}
